module.exports = __webpack_public_path__ + "img/feed.41174da9.png";